export const MultiStep = {
  list: [],
  step: 1,
  dataTestid: 'multi-step-content',
}
